import { HandleService } from "../../_services";

/**
 * Class API Back reprenant 1 export d'une liste de fichiers exportés vers console connectées
 * 
 */
export class ApiExportedFilesConnectedDeviceModels{

  /**datas */
  public Exports :ApiExportedFileConnectedDeviceModel[] 

  constructor() {
   this.Exports = [];
  }

 /**
  * Bind by json
  * @param _iJson json (ApiExportedFilesConnectedDeviceModels)
  * @param _iIsInitialise true: initialise la liste et ajout, false: ajout
  */
  public bindByJson(_iJson:any, _iIsInitialise:boolean = true){
    this.Exports = [];
    if(_iJson && _iJson.Exports && _iJson.Exports.length){
      _iJson.Exports.forEach((fJson:ApiExportedFileConnectedDeviceModel) => {
        if(fJson && fJson.FileExporting){
          let nws = new ApiExportedFileConnectedDeviceModel(fJson.FileExporting,true);
          nws.Status = fJson.Status;
          this.Add(nws);
        }
      });
    }
  }

  /**Indique si il dispose de données */
  public Exists():boolean{
    return this?.Exports?.length>0;
  }

  /**Ajout des données */
  public AddRange( _iAdd: ApiExportedFileConnectedDeviceModel[] ){
    this.Exports.push(... _iAdd);
  }

  /**ajout une donnée */
   public Add( _iAdd: ApiExportedFileConnectedDeviceModel ){
    this.Exports.push(_iAdd);
  }

/**
 * Maj du statut d'export connecté pour celle ci
 * @param _iLastStatus dernier statut
 * @param _iReplaceSameStatus indique si on remplace si on est sur le meme statut process
 * @returns 
 */
  public UpdateTransfertStatus(_iLastStatus: ApiExportedFileConnectedDeviceModel, _iReplaceSameStatus: boolean): boolean | null {
    if (_iLastStatus && _iLastStatus.GetExportRequestUid() != null) {
      let fndNdx = this.Exports.findIndex(t => t.GetExportRequestUid() == _iLastStatus.GetExportRequestUid());
      if (fndNdx > -1) {
        let fnd = this.Exports[fndNdx];
        if (fnd.FileExporting && _iLastStatus.FileExporting && _iLastStatus.FileExporting?.Connected) {
          let newStatus = !fnd.FileExporting?.Connected.eStatus || fnd.FileExporting?.Connected.eStatus != _iLastStatus.FileExporting?.Connected.eStatus || fnd.IsFinished !== _iLastStatus.IsFinished;
         
          if (newStatus || _iReplaceSameStatus) {
              fnd.FileExporting.Connected = _iLastStatus.FileExporting.Connected;      
            fnd.Status = _iLastStatus.Status;
            fnd.IsFinished = _iLastStatus.IsFinished;
           this.Exports[fndNdx] =fnd;

          }
         
          return newStatus;
        }
        return null;


      } else {
        return null;
      }
    } else {
      return null;
    }

  }
}

/**
 * Class API Back reprenant 1 export d'un fichier, et son statut de transfert vers une console connectée
 * 
 */
export class ApiExportedFileConnectedDeviceModel {

  /**back réponse */
  public FileExporting: ExportFileResponse | null;
  //le statut calculé
  public Status: eExportConnectedStatus = eExportConnectedStatus.Initial;
  //le statut est terminé back
  public IsFinished:boolean|null;

  /**
   * Init
   * @param _iExportFileResponse 
   * @param _iMapConnectedStatus si on contrôle les status connectés
   */
  constructor(_iExportFileResponse: ExportFileResponse | null, _iMapConnectedStatus: boolean) {
    this.FileExporting = _iExportFileResponse;
    this.IsFinished = null
    if (_iMapConnectedStatus && this.IsConnectedExport()) {
      this.MapFinalStatus();
    }

  }

  /**Si concerne un export console connectée  comportant un deveiceUid et un requestUid*/
  public IsConnectedExport(): boolean {
    return this.FileExporting?.Connected?.DeviceUid != null && this.GetExportRequestUid() != null;
  }

 /**Si d'un statut de transfert|send*/
  public IncludeConnectedState(): boolean {
    return this.FileExporting?.Connected?.States != null;
  }

 /**Si le traitement d export console est tjs en cours*/
  public IsConnectedSendInProgress(): boolean {
    return this.FileExporting?.Connected.IsInProgress == true;
  }

   /**retourne l'export requestUid*/
  public GetExportRequestUid(): string | null {
    return this?.FileExporting?.Connected?.ReqUid ?? null;
  }

   /**Si il dispose de donnée*/
  public Exists(): boolean {
    return this.FileExporting != null && this.FileExporting !== undefined;
  }

  /**
   * Mapping du statut final selon ceux recupéré coté api
   */
  private MapFinalStatus() {
    if (this.Exists()) {

      if (this.FileExporting?.Connected && this.FileExporting.Connected.IsInProgress == true && this.FileExporting.Connected?.States) {
        this.Status = ApiSendStatusMap[this.FileExporting.Connected.States.SendingStatusCode ?? ""] ?? eExportConnectedStatus.SendingInProgress;
        if (this.FileExporting.Connected?.States.TransfertStatusCode && this.FileExporting.Connected?.States.TransfertStatusCode !== "NONE") {
          this.Status = ApiTransfertStatusMap[this.FileExporting.Connected.States.TransfertStatusCode ?? ""] ?? eExportConnectedStatus.FailedOnTransfert
        }
      } else {
        //terminé
        if (this.FileExporting?.Connected?.States) {
          this.Status = ApiSendStatusMap[this.FileExporting.Connected?.States.SendingStatusCode ?? ""] ?? eExportConnectedStatus.SendingInProgress;
          if (this.FileExporting.Connected?.States.TransfertStatusCode && this.FileExporting.Connected?.States.TransfertStatusCode !== "NONE") {
            this.Status = ApiTransfertStatusMap[this.FileExporting.Connected?.States.TransfertStatusCode ?? ""] ?? eExportConnectedStatus.FailedOnTransfert
          }
        }
        //terminé mais pas d envoi
        if (!this.FileExporting?.Connected?.States || !this.FileExporting?.Connected?.States.SendingStatusCode || this.FileExporting?.Connected?.States.SendingStatusCode == "NONE") {
          this.Status = ApiExportConnectedStatusMap[this.FileExporting?.Connected.StatusCode ?? ""] ?? eExportConnectedStatus.FailedOnSending;
        }

      }
      if(this.FileExporting?.Connected?.States.IsFinish == true){
        //peut êtrer en QUEUE mais verification terminée donc on le termine
        this.IsFinished = true;
      }else if(this.FileExporting?.Connected?.States.IsFinish == false){
        this.IsFinished = false;
      }
    } else {
      this.Status = eExportConnectedStatus.FailedOnInitial;
    }
  }

}

/**
 * Status of process export connected device
 */
export enum eExportConnectedStatus {

  Initial = 0,
  SendingWaiting = 1,
  SendingInProgress = 2,
  TransfertWaiting = 3,
  TransfertInProgress = 4,
  Success = 5,//transfered
  RejectedByUser = 6,//transfered but refused by user
  FailedOnInitial = 7,//echec si les contrôle compte device données
  FailedOnConnection = 8,//echec authentification de compte ou device
  FailedOnSending = 9,
  FailedOnTransfert = 10,
  FailedAccount = 11,

}

/**Interface export file connected device */
export interface ExportFileResponse {
  /**export Uid */
  Uid: string;
  /**export file name */
  Name: string;
  downloadFileType: string;
  /**blob filetype */
  blobFileType: string;
  /**information export connected process */
  Connected: ApiConnectedDeviceTransfertStats;
  /**if the file is still available on server (reset server lost file) */
  IsStillAvailable: boolean;
}

/**Interface connected export process state */
export interface ApiConnectedDeviceTransfertStats {
  ReqUid: string;
  FileName: string;
  DeviceUid: string;
  Description: string;
  //id du statut process export global
  eStatus: number;
  //code du statut process export global
  StatusCode: string;
  SendingAt: string;
  SendingEnd: string;
  //Account device transfert states
  States: ApiExportedAccountFileState;
  IsInProgress: boolean;
}

/**State Send to Account Device */
export interface ApiExportedAccountFileState {
  SendAccountFileId: string | null;
  ProcessError: string | null;
  SendingStatusCode: string | null;
  SendingStatusDescription: string | null;
  TransfertStatusCode: string | null;
  TransfertStatusDescription: string | null;
  IsFinish: boolean;
}


/**
 * Mapping des codes de statut de transfert entre les statut back code 
 * et le statut final à afficher
 */
const ApiTransfertStatusMap: Record<string, eExportConnectedStatus> = {
  QUEUE: eExportConnectedStatus.TransfertWaiting,
  NONE: eExportConnectedStatus.Initial,
  INPROGRESS: eExportConnectedStatus.TransfertInProgress,
  DONE: eExportConnectedStatus.Success,
  REJECTEDBYUSER: eExportConnectedStatus.RejectedByUser,
  ECHEC: eExportConnectedStatus.FailedOnTransfert,
  EXCEPTION: eExportConnectedStatus.FailedOnTransfert,
};


/**
 * Mapping des codes de statut de transfert entre les statut back code 
 * et le statut final à afficher
 */
const ApiSendStatusMap: Record<string, eExportConnectedStatus> = {

  NONE: eExportConnectedStatus.SendingWaiting,
  DONE: eExportConnectedStatus.TransfertWaiting,
  REJECTEDBYUSER: eExportConnectedStatus.RejectedByUser,
  SERVERINTERNALERROR: eExportConnectedStatus.FailedOnSending,
  EMPTYDATAUNAUTHORIZED: eExportConnectedStatus.FailedOnSending,
  ACCOUNTFAILAUTH: eExportConnectedStatus.FailedAccount,
  ACCOUNTAPIEXCEPTION: eExportConnectedStatus.FailedAccount,
  EXCEPTIONSENDING: eExportConnectedStatus.FailedOnSending,
  APIERRORUNMANAGED: eExportConnectedStatus.FailedOnSending,
  INVALIDFILENAME: eExportConnectedStatus.FailedOnSending,
  INVALIDDATA: eExportConnectedStatus.FailedOnSending,
  ZEROLENGTHS: eExportConnectedStatus.FailedOnSending,
};

/**
 * Mapping des codes de statut d'export venant du back
 * et le statut final à afficher
 */
const ApiExportConnectedStatusMap: Record<string, eExportConnectedStatus> = {

  INITIAL: eExportConnectedStatus.Initial,
  REQUESTSENDAPI: eExportConnectedStatus.SendingWaiting,
  INPROGRESS: eExportConnectedStatus.SendingWaiting,
  INPROGRESSENDDEVICE: eExportConnectedStatus.SendingInProgress,
  INPROGRESSTRANSFERTDEVICE: eExportConnectedStatus.TransfertInProgress,
  SUCCESS: eExportConnectedStatus.Success,
  DEVICEREJECT: eExportConnectedStatus.RejectedByUser,
  FAILEDUNAUTHORISED: eExportConnectedStatus.FailedAccount,
  FAILEDDEVICEAPINOTFOUND: eExportConnectedStatus.FailedAccount,
  FAILEDACCOUNTAPINOTFOUND: eExportConnectedStatus.FailedAccount,
  FAILEDACCOUNTNOTCONNECTED: eExportConnectedStatus.FailedAccount,
  FAILEDACCOUNTREQTOKEN: eExportConnectedStatus.FailedAccount,
  FAILEDACCOUNTDEVICENOTCONNECTED: eExportConnectedStatus.FailedAccount,
  FAILEDUNDETERMINED: eExportConnectedStatus.FailedOnInitial,
  FAILEDARGUMENT: eExportConnectedStatus.FailedOnInitial,
  FAILEDONSENDING: eExportConnectedStatus.FailedOnSending,
  FAILEDONTRANSFERT: eExportConnectedStatus.FailedOnTransfert,
};

